import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { login as apiLogin, me as apiMe } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  // null = checking, false = unauthenticated, object = user
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("blog_token");
    if (!token) {
      setUser(false);
      return;
    }
    try {
      const u = await apiMe();
      setUser(u);
    } catch (e) {
      localStorage.removeItem("blog_token");
      setUser(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const data = await apiLogin(email, password);
    localStorage.setItem("blog_token", data.access_token);
    await refresh();
  };

  const logout = () => {
    localStorage.removeItem("blog_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
